/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_email = /** @type {(inputs: {}) => string} */ () => {
	return `E-mail`
};

const da_email = /** @type {(inputs: {}) => string} */ () => {
	return `Email`
};

const de_email = /** @type {(inputs: {}) => string} */ () => {
	return `E-Mail`
};

const en_email = /** @type {(inputs: {}) => string} */ () => {
	return `Email`
};

const es_email = /** @type {(inputs: {}) => string} */ () => {
	return `Correo electrónico`
};

const fr_email = /** @type {(inputs: {}) => string} */ () => {
	return `Email`
};

const hu_email = /** @type {(inputs: {}) => string} */ () => {
	return `E-mail`
};

const it_email = /** @type {(inputs: {}) => string} */ () => {
	return `Email`
};

const nl_email = /** @type {(inputs: {}) => string} */ () => {
	return `E-mail`
};

const pl_email = /** @type {(inputs: {}) => string} */ () => {
	return `E-mail`
};

const pt_email = /** @type {(inputs: {}) => string} */ () => {
	return `Email`
};

const sv_email = /** @type {(inputs: {}) => string} */ () => {
	return `E-post`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const email = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.email(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("email", locale)
	if (locale === "cs") return cs_email(inputs)
	if (locale === "da") return da_email(inputs)
	if (locale === "de") return de_email(inputs)
	if (locale === "en") return en_email(inputs)
	if (locale === "es") return es_email(inputs)
	if (locale === "fr") return fr_email(inputs)
	if (locale === "hu") return hu_email(inputs)
	if (locale === "it") return it_email(inputs)
	if (locale === "nl") return nl_email(inputs)
	if (locale === "pl") return pl_email(inputs)
	if (locale === "pt") return pt_email(inputs)
	return sv_email(inputs)
};